import type { ConceptDef } from '../types';

export const echoicSingleSounds: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-single-sounds',
  label: 'Echoic Single Sounds',
  category: 'Echoic',
  description: 'Speak a single sound; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'ah' },
      { prompt: 'ee' },
      { prompt: 'oo' },
      { prompt: 'mm' },
      { prompt: 'ss' },
      { prompt: 'ff' },
      { prompt: 'sh' },
      { prompt: 'th' },
    ],
  },
};
